/**
 * created by tian ruo jun
 表单子项
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Input, Select} from "antd";
import {formItemSizeConfig} from "../information-config";

const {TextArea} = Input;

export default class RmtText extends Component {
    static defaultProps = {
        type: "text",
        onChange: () => {
        },
        value: "",
    };
    static propTypes = {
        type: PropTypes.string.isRequired,
        onChange: PropTypes.func,
    };

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        let {value, disabled, field, onChange} = this.props;
        return <Input
            size={formItemSizeConfig.inputSize}
            placeholder={`请输入`}
            disabled={disabled}
            value={value}
            onChange={(e) => {
                let val = e.target.value || '';
                onChange(field, val)
            }}
        />

    }

}